<div class="devops-builds">
  <section class="devops-builds__card" data-testid="ci-builds" aria-labelledby="ci-builds-heading">
    <to-section-title
      headingId="ci-builds-heading"
      [title]="'liveDashboard.devops.builds.ciTitle' | translate"
      [subtitle]="'liveDashboard.devops.builds.ciSubtitle' | translate"
    >
      <span
        right
        class="devops-builds__ci-link"
        data-testid="ci-open-link"
        aria-disabled="true"
        tabindex="0"
        [matTooltip]="'liveDashboard.devops.builds.ciNoIntegration' | translate"
      >
        {{ 'liveDashboard.devops.builds.ciOpen' | translate }}
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </span>
    </to-section-title>
    <ul class="devops-builds__list devops-builds__list--builds">
      @for (build of builds; track build.id) {
        <li class="ci-build" data-testid="ci-build" [attr.data-status]="build.status">
          <code class="ci-build__id" data-testid="ci-build-id">{{ build.id }}</code>
          <div class="ci-build__text">
            <div class="ci-build__commit" data-testid="ci-build-commit">{{ build.commit }}</div>
            <div class="ci-build__meta" data-testid="ci-build-meta">{{ build.author }} · {{ build.dauer }}</div>
          </div>
          <app-tc-status-pill
            [kind]="build.status"
            [label]="'liveDashboard.devops.builds.status.' + build.status | translate"
          />
        </li>
      }
    </ul>
  </section>

  <section class="devops-builds__card" data-testid="incidents" aria-labelledby="incidents-heading">
    <to-section-title
      headingId="incidents-heading"
      [title]="'liveDashboard.devops.builds.incidentsTitle' | translate"
      [subtitle]="'liveDashboard.devops.builds.incidentsSubtitle' | translate"
    />
    <ul class="devops-builds__list devops-builds__list--incidents">
      @for (incident of incidents; track incident.id) {
        <li class="incident" data-testid="incident" [attr.data-status]="incident.status">
          <span class="incident__icon" aria-hidden="true">
            <mat-icon>{{ incident.icon }}</mat-icon>
          </span>
          <div class="incident__body">
            <div class="incident__head">
              <code class="incident__id" data-testid="incident-id">{{ incident.id }}</code>
              <span class="incident__title" data-testid="incident-title">{{ incident.titel }}</span>
            </div>
            <div class="incident__desc" data-testid="incident-desc">{{ incident.desc }}</div>
            <div class="incident__meta" data-testid="incident-meta">
              <app-avatar [name]="incident.owner" [size]="16" />
              {{ incident.owner }} · {{ incident.time }}
            </div>
          </div>
          <span class="incident__badge" data-testid="incident-badge">
            {{ 'liveDashboard.devops.builds.incident.' + incident.status | translate }}
          </span>
        </li>
      }
    </ul>
  </section>
</div>
